import type { PartnerHotelOutOfCatalogSummary } from "@/types/partner-order";

/**
 * Money rule (owner, R-068 and R-098, DV-120 round 5): the tenant and the
 * hotel see only the hotel's own share of the partner commission, never an
 * order sum and never the whole commission. The share has three names:
 * Earned (confirmed by the Viator report), Expected (still an estimate) and
 * Total (Earned + Expected).
 *
 * Input is either the orders summary (`partnerRevenue` = Total share,
 * `totalRevenue` = order value, which is not shown) or the total-revenue
 * summary (`totalRevenue` = Total share, no `partnerRevenue`). The
 * `outOfCatalog.pendingEarnings` field is the Expected part outside the
 * catalog; a backend that does not send it gives 0.
 */
export interface PartnerSummaryMoneyInput {
  totalRevenue: number;
  partnerRevenue?: number;
  earnings: number;
  pendingEarnings: number;
  currency: string;
  outOfCatalog: PartnerHotelOutOfCatalogSummary;
}

export interface PartnerSummaryMoney {
  /** Earned + Expected. */
  total: number;
  earned: number;
  expected: number;
  currency: string;
  outOfCatalog: {
    count: number;
    earned: number;
    expected: number;
  };
}

export function mapPartnerSummaryMoney(
  summary: PartnerSummaryMoneyInput,
): PartnerSummaryMoney {
  return {
    total: summary.partnerRevenue ?? summary.totalRevenue,
    earned: summary.earnings,
    expected: summary.pendingEarnings,
    currency: summary.currency,
    outOfCatalog: {
      count: summary.outOfCatalog.count,
      earned: summary.outOfCatalog.earnings,
      expected: summary.outOfCatalog.pendingEarnings ?? 0,
    },
  };
}
